import * as THREE from 'three';
import HullComponent from './hull_component.js';
import * as materials from './materials.js';
import * as BufferGeometryUtils from "three/examples/jsm/utils/BufferGeometryUtils.js";

export default class Primary extends HullComponent{
  constructor() {
    super();
    this.group = new THREE.Group();
    this.group.rotateX( Math.PI / 2.0); 
    this.geometry = {};
    this.bridgeGeometry = {};
    this.meshLeft = {};
    this.bridgeMesh = {};
    this.dimensions = {};
    this.stretchFactor = 1.0;

    return this;
  }

  update({
    thickness,
    radius,
    widthRatio,
    bridgeThickness,
    bridgeRadius,
    bridgeWidthRatio,
    bridgeZ,
    bridgeY,
    pointiness, // 0.0-2.0
    notchAngle=0,
    notchAngleAft=0,
    segments=64,
    bridgeSegments=64,
    windowsY=0,
    windowsRepeatX=0.1,
    windowsRepeatY=0.1,
    materialIndex=0,
  }) {
    bridgeSegments = segments = 64;

    this.clear();
    this.pointiness = pointiness;

    this.points = [];
    const saucerPointCount = 80;
    for ( var i = 0; i <= saucerPointCount; i ++ ) {
      const lowerSquash = (i-10 > saucerPointCount * 0.5) ? 0.85 : 1.0;
      const lowerOffset = (i-10 > saucerPointCount * 0.5) ? 0.0 : 0.0;
      this.points.push(
        new THREE.Vector2( 
          (Math.sin( i / saucerPointCount * Math.PI ) * radius) ** 0.7 * 2.0,
          (i / saucerPointCount * thickness ) ** lowerSquash
        ) 
      );
    }

    var bridgePoints = [];
    for ( var i = 0; i <= saucerPointCount; i ++ ) {
      bridgePoints.push(
        new THREE.Vector2( 
          (Math.sin( i / saucerPointCount * Math.PI ) * radius * bridgeRadius) ** 0.5 * 3.0,
          i / saucerPointCount * thickness * bridgeThickness
        ) 
      );
    }
    i = bridgePoints.length;
    // bridgePoints[0].y = bridgePoints[1].y;
    // bridgePoints[i-1].y = bridgePoints[i-2].y;

    const foreExclusionAngle = notchAngle;
    const aftExclusionAngle = notchAngleAft;
    // const this.geometryLeft = new THREE.LatheGeometry(points, segments, Math.PI + foreExclusionAngle, 2.0 * ( Math.PI - foreExclusionAngle - aftExclusionAngle) );
    this.geometryLeft = new THREE.LatheGeometry(this.points, segments, Math.PI + foreExclusionAngle, ( Math.PI - foreExclusionAngle - aftExclusionAngle) );
    this.geometryRight = new THREE.LatheGeometry(this.points, segments, Math.PI * 0.0 + aftExclusionAngle, ( Math.PI - foreExclusionAngle - aftExclusionAngle) );
    this.mergedSaucerGeometry = BufferGeometryUtils.mergeGeometries([this.geometryLeft, this.geometryRight]);

    this.geometryLeft.scale(widthRatio, 1.0, 1.0);
    this.geometryRight.scale(widthRatio, 1.0, 1.0);
    this.computeBoundingBox(this.mergedSaucerGeometry);
    this.lengthZ = this.mergedSaucerGeometry.boundingBox.max.z - this.mergedSaucerGeometry.boundingBox.min.z;

    // const s = bridgeWidthRatio;
    // const matrix = new THREE.Matrix4();

    // matrix.set(   1,     0,   0,   0,
    //               0,     1,   0,   0,
    //               0,     0,   1,   0,
    //               0,     0,   0,   1  );
    // this.geometry.applyMatrix4( matrix );

    this.bridgeGeometry = new THREE.LatheGeometry(bridgePoints, bridgeSegments, Math.PI, 2.0 * Math.PI );
    this.bridgeGeometry.scale(bridgeWidthRatio, 1.0, 1.0);
    this.bridgeGeometry.scale(widthRatio * bridgeWidthRatio, 1.0, 1.0);
    this.computeBoundingBox(this.bridgeGeometry);
    // const bridgeLengthZ = this.bridgeGeometry.geometry.max.z - this.bridgeGeometry.boundingBox.min.z;

    // add egg distort:
    this.pointinessDistort(this.geometryLeft);
    this.pointinessDistort(this.geometryRight);

    const ringsLeft = this.generateEndPlatesForGeometry(this.geometryLeft);
    const ringsRight = this.generateEndPlatesForGeometry(this.geometryRight);

    const closeMesh1 = new THREE.Mesh(this.createCapGeometry(ringsLeft.startRing), materials.notchMaterial[materialIndex].clone() );
    const closeMesh2 = new THREE.Mesh(this.createCapGeometry(ringsLeft.endRing), materials.notchMaterial[materialIndex].clone() );

    const closeMesh3= new THREE.Mesh(this.createCapGeometry(ringsRight.startRing), materials.notchMaterial[materialIndex].clone() );
    const closeMesh4 = new THREE.Mesh(this.createCapGeometry(ringsRight.endRing), materials.notchMaterial[materialIndex].clone() );

    // this.computeBoundingBox(this.geometry);
    const hullMaterial = materials.hullMaterial[materialIndex].clone()
    const tex = hullMaterial.emissiveMap;
    tex.repeat.set(windowsRepeatX, windowsRepeatY);
    tex.offset.set(0.0, windowsY);

    this.meshLeft = new THREE.Mesh( this.geometryLeft, hullMaterial );
    this.meshRight = new THREE.Mesh( this.geometryRight, hullMaterial );
    this.bridgeMesh = new THREE.Mesh( this.bridgeGeometry, materials.bridgeMaterial[materialIndex].clone() );
    this.bridgeMesh.position.y = - bridgeZ - ( bridgeThickness * 0.4);
    this.bridgeMesh.position.z = radius * bridgeY;
    
    this.group.add( this.meshLeft );
    this.group.add( this.meshRight );
    this.group.add( this.bridgeMesh );
    if (notchAngle > 0.0) {
      this.group.add( closeMesh1 );
      this.group.add( closeMesh4 );
    }
    if (notchAngleAft > 0.0) {
      this.group.add( closeMesh2 );
      this.group.add( closeMesh3 );
    }

    this.computeBoundingBox(this.mergedSaucerGeometry);
  }

  pointinessDistort(geometry) {
    const positions = geometry.attributes.position.array;
    
    let aftMax = -9999999.0;
    let foreMax = 9999999.0;
    for (let i = 0; i < positions.length; i += 3) {
      let z = positions[i + 2]; // Get Z value
      let zNormalized = z / this.lengthZ;
      let stretchFactor = Math.pow(1.0 + zNormalized, this.pointiness);
      stretchFactor = stretchFactor;
      let newZ = z / stretchFactor; // Stretch along the Z-axis
      positions[i + 2] = newZ; // Update Z position

      if (newZ > aftMax) aftMax = newZ;
      if (newZ < foreMax) foreMax = newZ;
    }
    this.dimensions.center = (aftMax + foreMax) / 2.0
    this.dimensions.aft = aftMax;
    this.dimensions.fore = foreMax;
    
    geometry.attributes.position.needsUpdate = true;
  }

  // Notch end plates:
  generateEndPlatesForGeometry(geometry) {
    const posAttr = geometry.attributes.position;
    const vertices = [];
    for (let i = 0; i < posAttr.count; i++) {
      vertices.push(new THREE.Vector3().fromBufferAttribute(posAttr, i));
    }

    const profileCount = this.points.length;

    // Get start ring (angle = 0)
    const startRing = [];
    for (let i = 0; i < profileCount; i++) {
      startRing.push(vertices[i]);
    }

    // Get end ring (angle = sweep angle)
    const endRing = [];
    for (let i = 0; i < profileCount; i++) {
      endRing.push(vertices[vertices.length - profileCount + i]);
    }
    return {startRing:startRing, endRing:endRing};
  }

  computeBoundingBox(measuredGeom) {
    if(!measuredGeom["computeBoundingBox"]) {
      return;
    }
    measuredGeom.computeBoundingBox();
    this.dimensions.x = measuredGeom.boundingBox.max.x - measuredGeom.boundingBox.min.x;
    this.dimensions.y = measuredGeom.boundingBox.max.y - measuredGeom.boundingBox.min.y;
    this.dimensions.z = measuredGeom.boundingBox.max.z - measuredGeom.boundingBox.min.z;
  }

  createCapGeometry(ring, uRepeat = 20, vRepeat = 4) {
    if (ring.length < 3) throw new Error("Need at least 3 points");
  
    const center = new THREE.Vector3();
    ring.forEach(p => center.add(p));
    center.divideScalar(ring.length);
  
    const allPoints = [center, ...ring];
  
    // Project to 2D (assume cap lies roughly in XY plane)
    const projected = allPoints.map(p => new THREE.Vector2(p.x, p.y));
  
    // Find bounds
    let minX = Infinity, maxX = -Infinity;
    let minY = Infinity, maxY = -Infinity;
    for (const p of projected) {
      minX = Math.min(minX, p.x);
      maxX = Math.max(maxX, p.x);
      minY = Math.min(minY, p.y);
      maxY = Math.max(maxY, p.y);
    }
  
    const width = maxX - minX;
    const height = maxY - minY;
  
    // Generate UVs in [0, 1] and apply repeat scaling
    const uvs = projected.map(p => [
      ((p.x - minX) / width) * uRepeat,  // Apply U repeat scaling
      ((p.y - minY) / height) * vRepeat, // Apply V repeat scaling
    ]).flat();
  
    // Build positions and indices
    const positions = allPoints.map(p => p.toArray()).flat();
    const indices = [];
  
    for (let i = 1; i <= ring.length; i++) {
      const a = 0; // center
      const b = i;
      const c = (i % ring.length) + 1;
      indices.push(a, b, c);
    }
  
    const geometry = new THREE.BufferGeometry();
    geometry.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3));
    geometry.setAttribute('uv', new THREE.Float32BufferAttribute(uvs, 2));
    geometry.setIndex(indices);
    geometry.computeVertexNormals();
  
    return geometry;
  }

  clear(){
    try {
      this.geometryLeft.dispose();
      this.geometryRight.dispose();
      this.bridgeGeometry.dispose();
      this.mergedSaucerGeometry.dispose();
    } catch(e) {
      // pass
    }
    for (var i = this.group.children.length - 1; i >= 0; i--) {
      this.group.remove(this.group.children[i]);
    }
  }
}